/*
  Just Tattoos — wishlist toggle. Stores saved product ids in localStorage
  under "jt:wishlist" and reflects state on every [data-wishlist-toggle].
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'jt:wishlist';
  var doc = document;

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (err) { return []; }
  }
  function write(ids) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch (err) { /* private mode */ }
  }
  function reflect(button, saved) {
    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var addLabel = button.getAttribute('data-label-add');
    var removeLabel = button.getAttribute('data-label-remove');
    if (saved && removeLabel) button.setAttribute('aria-label', removeLabel);
    else if (!saved && addLabel) button.setAttribute('aria-label', addLabel);
  }

  function init() {
    var ids = read();
    Array.prototype.slice.call(doc.querySelectorAll('[data-wishlist-toggle]')).forEach(function (button) {
      var id = String(button.getAttribute('data-product-id') || '');
      if (!id) return;
      reflect(button, ids.indexOf(id) !== -1);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var current = read();
        var index = current.indexOf(id);
        var nowSaved;
        if (index === -1) { current.push(id); nowSaved = true; } else { current.splice(index, 1); nowSaved = false; }
        write(current);
        reflect(button, nowSaved);
        doc.dispatchEvent(new CustomEvent('wishlist:changed', { bubbles: true, detail: { productId: id, saved: nowSaved, items: current } }));
      });
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
